<template>
  <section>
    <b-loading :is-full-page="true" v-model="loading" :can-cancel="true"></b-loading>

    <b-field horizontal label="Название">
      <b-input name="subject" expanded v-model="name"></b-input>
    </b-field>

    <b-field horizontal label="WebHook №">
      <b-input type="subject" expanded v-model="webhookId"></b-input>
    </b-field>

    <b-field horizontal>
      <p class="control">
        <b-button label="Сохранить" type="is-primary" @click="edit()" :disabled="loading"/>
      </p>
    </b-field>
  </section>
</template>

<script>
import whatsappAccountsRepository from '../../repository/whatsappAccountsRepository';

export default {
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  data () {
    return {
      name: null,
      webhookId: null,
      loading: false,
    };
  },
  methods: {
    fetchData () {
      this.loading = true;

      whatsappAccountsRepository.get(this.id)
      .then(({data}) => {
        this.name = data.name;
        this.webhookId = data.webhookId;
      })
      .finally(() => {
        this.loading = false;
      });
    },
    edit () {
      this.loading = true;

      whatsappAccountsRepository.update(this.id, this.name, this.webhookId)
      .then(() => this.$router.push({name: 'WhatsAppAccounts'}))
      .then(() => this.$buefy.toast.open('Успешно обновлено'))
      .catch(() => this.$buefy.toast.open('Ошибка при обновлении'))
      .finally(() => {
        this.loading = false;
      });
    },
  },
  mounted () {
    this.fetchData();
  },
};
</script>